<app-tree-view
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  [activeNodes]="activeNodes"
></app-tree-view>
